import { Flame, Phone } from "lucide-react";
import { SERVICES_SEO, CITIES } from "@/data/servicePages";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-white/70 py-16 pb-28 md:pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
                <Flame className="w-5 h-5 text-white" strokeWidth={2} />
              </span>
              <span className="font-heading font-bold text-lg tracking-tight text-white">
                Exotictileandmasonry
              </span>
            </div>
            <p className="text-sm leading-relaxed">
              Chimney sweeping, repair, and masonry specialists serving the greater
              Portland, Oregon area.
            </p>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li>Chimney Sweeping — $249 Special</li>
              <li>Chimney Repair</li>
              <li>Crowns, Caps & Flashing</li>
              <li>Tuckpointing</li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Contact</h4>
            <a
              href="tel:+19712553874"
              data-testid="footer-call-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-primary transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={2} />
              971-255-3874
            </a>
            <p className="text-sm mt-4">
              Portland · Hillsboro · Clackamas · Beaverton · Tualatin
            </p>
          </div>
        </div>
        <div className="mt-12" data-testid="footer-service-areas">
          <h4 className="font-heading font-semibold text-white mb-6">Services by City</h4>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {SERVICES_SEO.map((s) => (
              <div key={s.slug}>
                <p className="text-xs uppercase tracking-[0.15em] font-bold text-white/50 mb-3">
                  {s.name}
                </p>
                <ul className="space-y-1.5">
                  {CITIES.map((c) => (
                    <li key={c.slug}>
                      <a
                        href={`/services/${s.slug}/${c.slug}`}
                        data-testid={`footer-link-${s.slug}-${c.slug}`}
                        className="text-xs hover:text-white transition-colors"
                      >
                        {c.name}, OR
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs">
            © {new Date().getFullYear()} Exotictileandmasonry. All rights reserved.
          </p>
          <a href="/admin" data-testid="footer-admin-link" className="text-xs hover:text-white transition-colors">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
